/* React */
import React from "react";

/* Components */
import DevOptionsContainer from "src/components/admin-dashboard/settings/dev-options-container/DevOptionsContainer";

const Settings: React.FC = () => {
  return (
    <>
      <DevOptionsContainer />
    </>
  );
};

export default Settings;
